import { BannerFragment } from '@/fo/api/magento';
import { ContentWithFootnoteSup } from '@/fo/ui/mod/footnote/base';

import { Banner } from '../lib/UiKitBannerHero';

export const mapBannersFromData = (banners: BannerFragment[]): Banner[] => {
  return banners
    .filter((banner) => banner.banner_type === 'SLIDER_ITEM')
    .map((banner) => ({
      image: {
        sm: banner.banner_data?.mobile_image || '',
        md: banner.banner_data?.desktop_image || ''
      },
      label: banner.banner_data?.title || '',
      brandColor: (banner.banner_data?.disclaimer_text || '').toLowerCase(),
      title: (
        <ContentWithFootnoteSup
          id={banner.id}
          content={banner.banner_data?.large_text || ''}
        />
      ),
      description: (
        <ContentWithFootnoteSup
          id={banner.id}
          content={banner.banner_data?.small_text || ''}
        />
      ),
      buttonText: banner.banner_data?.first_link_label || '',
      link: banner.banner_data?.first_link || '',
      mode: banner.banner_data?.theme === 'LIGHT' ? 'light' : 'dark',
      alt: banner.banner_data?.desktop_image_alt || '',
      linkPageText: banner.banner_data?.second_link_label || '',
      target: banner.banner_data?.first_link_new_tab || false
    }));
};

export const getSpeedFromData = (banners: BannerFragment[]) => {
  return (
    banners.filter((banner) => banner.entity_type === 'SLIDER')[0]?.banner_data
      .slide_speed || 10000
  );
};

export const mapMainBannersFromData = (banners: BannerFragment[]): Banner[] => {
  return banners.map((banner) => ({
    image: {
      sm: banner.banner_data?.mobile_image || '',
      md: banner.banner_data?.desktop_image || ''
    },
    label: banner.banner_data?.disclaimer_text || '',
    brandCode: (banner.banner_data?.disclaimer_text || '').toLowerCase(),
    title: (
      <ContentWithFootnoteSup
        id={banner.id}
        content={banner.banner_data?.large_text || ''}
      />
    ),
    description: (
      <ContentWithFootnoteSup
        id={banner.id}
        content={banner.banner_data?.small_text || ''}
      />
    ),
    buttonText: banner.banner_data?.first_link_label || '',
    link: banner.banner_data?.first_link || '',
    mode: banner.banner_data?.theme === 'LIGHT' ? 'light' : 'dark',
    alt: banner.banner_data?.desktop_image_alt || '',
    target: banner.banner_data?.first_link_new_tab || false
  }));
};
